import { Loader } from '@Sage/hoi-poi-ui';
import useCheckInitialSetup from '../hooks/useCheckInitialSetup';

import './SetupCheckerWrapper.scss';

export default function SetupCheckerWrapper({ children }) {
    const { isLoading } = useCheckInitialSetup();

    if (isLoading) {
        return (
            <div className="setup-checker-wrapper">
                <Loader size="large" />
            </div>
        );
    }

    return children;
}
